import { NotificationType } from '@/alert/utils/notification.types';

/**
 * 저장된 알림 결과의 methodType을 클라이언트 표준 NotificationType으로 정규화한다.
 *
 * alerter(smtpmail)는 email 채널을 NotifyType="mail"로 저장하지만, 서버 알림 상태 API의
 * `@PathVariable MethodType` enum과 클라이언트 아이콘/라벨 매핑(NOTIFICATION_ICON_KEY 등)은
 * "email"을 기준으로 한다. 알림 상태 진입 경로(이벤트 알람 목록·상세, 알람 상세 History)가
 * 각기 정규화하면 화면 간 drift가 생기므로 모든 경로에서 이 함수를 거쳐 "mail" → "email"로 통일한다.
 *
 * @param methodType 원본 methodType (예: "mail", "slack")
 * @returns 정규화된 NotificationType (예: "email", "slack")
 * @example
 * normalizeNotificationMethodType('mail');  // 'email'
 * normalizeNotificationMethodType('slack'); // 'slack'
 */
// 백엔드 methodType은 임의 문자열이라 정적으로 union 증명 불가 — 유일한 단언을 이 유틸 한 곳에 모은다.
export const normalizeNotificationMethodType = (methodType?: string): NotificationType =>
  (methodType === 'mail' ? 'email' : methodType) as NotificationType;
